module.exports = __webpack_public_path__ + "img/icon-open-popup-round.0276db3e.svg";